import { makeStyles } from '@material-ui/core'
import React from 'react'
import Banner from '../components/Banner'
import CoinsTable from '../components/CoinsTable'




function HomePage() {
  return (
   <>
    <CoinsTable/>
   <Banner />
  
   </>
  )
}

export default HomePage